import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full uppercase tracking-wider">
            Shop by Category
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-3">
            All Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            One Click Away — browse every category in our CSSBuy spreadsheet collection
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-100/60 transition-all duration-300 border border-background-200/60 hover:border-primary-200/60 cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 40}ms` }}
            >
              <div className="w-11 h-11 rounded-lg bg-secondary-100 group-hover:bg-primary-200 flex items-center justify-center mb-4 transition-colors duration-300">
                <i className={`${cat.icon} text-foreground-700 group-hover:text-primary-700 text-lg w-5 h-5 flex items-center justify-center transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-800 mb-1.5 transition-colors duration-300">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 group-hover:text-primary-600/70 leading-relaxed transition-colors duration-300">
                {cat.description}
              </p>
              <div className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span>Browse</span>
                <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}